<template>
    <div class="mine-wrapper" v-if="!store.isInputFocus" :style="{ 'bottom': storeCommon.inTopTab ? '-0.3rem' : '0' }">
        <qmWxBtn>
            <img class="mine-bg" src="@/assets/images/wish_pop_img_xuanfu.png" alt="">
            <div class="mine-content">
                <p class="mine-task" @click="handleMineClick('task')"></p>
                <p class="mine-vote-count">
                    <span class="mine-vote-count-num qm-number">{{ store.pageData?.vote_num || 0 }}</span>
                    <span class="mine-vote-count-unit qm-zhjkh">张</span>
                </p>
                <p class="mine-history" @click="handleMineClick('history')"></p>
            </div>
        </qmWxBtn>
    </div>
</template>
<script lang="ts" setup>
import { useStoreCommon } from '@common/store/common';
import { useStore } from '../store';
import { handleLogin } from '@common/assets/ts/utils';
import qmWxBtn from '@common/components/qm-wx-btn.vue';
const store = useStore();
const storeCommon = useStoreCommon();

const emit = defineEmits(['click']);
const handleMineClick = (type: string) => {
    if (!handleLogin(storeCommon.userInfo.user_type.toString())) return;
    emit('click', type);
};
</script>
<style lang="scss" scoped>
.mine-wrapper {
    position: fixed;
    width: 720px;
    bottom: 0;
    left: calc(50vw - 360px);
    z-index: 20;
}
.mine-bg {
    width: 100%;
}
.mine-content {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    display: flex;
}
.mine-task, .mine-history {
    width: 20%;
    height: 80%;
    margin-left: 3%;
}
.mine-vote-count{
    flex: 1;
    margin-left: 3%;
    padding-top: 18px;
    font-weight: bold;
    font-size: 32px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 48px;
    .mine-vote-count-num {
        font-weight: bold;
        font-size: 48px;
        color: #FFFFFF;
        margin-right: 4px;
        line-height: 48px;
    }
    .mine-vote-count-unit {
        font-size: 40px;
        color: #FFFFFF;
        line-height: 48px;
        padding-bottom: 8px;
        font-weight: normal;
    }
}
.mine-history {
    margin-right: 3%;
}
</style>
